import { Save } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../../Models/User';
import datas from "../../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../../Functions/Security/Crypter';
import { FormSection, FormActions, useAlert, Spin, Input, Select, Button, FileUpload } from '../../ui';
import { UploadedFile } from '../../ui/FileUpload';


export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

export interface Ticket {
    numeroFile: string,
    guichet: string,
    agence: String
}

const FormUpdateUser = (props: { user: any, handleFunction: any }) => {
    // USER TOKEN
    const authHeader = useAuthHeader()

    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert()

    const { register, handleSubmit, setValue, reset } = useForm()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const [entiteVal, setEntiteVal] = React.useState(props.user?.CodeFiliale);
    const [serviceVal, setServiceVal] = React.useState(props.user?.CodeS);

    const [entites, setEntites] = React.useState([]);
    const [services, setServices] = React.useState([]);
    const [allServices, setAllServices] = React.useState([]);

    const [previewImage, setPreviewImage] = useState<string>(props.user?.Image || '');
    const [fileList, setFileList] = useState<UploadedFile[]>([{ uid: "", name: "photo", url: props.user?.Image || '' }]);

    useEffect(() => {
        loadEntiteServices()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function loadEntiteServices() {
        const codeAbonne = user.CodeAbonne
        setLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.GetFilialeServices + Crypter.encrypt(codeAbonne),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    setLoading(false)

                    setEntites(res.Result[0])
                    setAllServices(res.Result[1])
                    setServices(res.Result[1].filter((s: any) => s.CodeFiliale == props.user?.CodeFiliale))


                }
                else {
                    setLoading(false)
                    setEntites([])
                    setServices([])
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                alert.error('Error', error)
                setLoading(false)
                console.log(error);
            });
    }


    const onSubmit = async (data: any) => {
        if (fileList.length > 0) {
            const fichier = fileList[0].thumbUrl ? fileList[0].thumbUrl : previewImage

            if (fichier && entiteVal && serviceVal) {

                setLoading(true)
                data = { ...data, CodeU: props.user.CodeU, "Image": fichier, "CodeS": serviceVal, "CodeFiliale": entiteVal, "CodeAbonne": user.CodeAbonne }

                let config = {
                    method: 'put',
                    maxBodyLength: Infinity,
                    url: env.API_BASE_URL + datas.API_LINKs.UpdateUser,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': authHeader(),
                    },
                    data: Crypter.encrypt(JSON.stringify(data))
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false)
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value
                        if (res.StatutCode == 200) {
                            //localStorage.setItem("loadQmGuichet", "1")
                            alert.success(res.Message)
                            reset()
                            props.handleFunction()
                        } else {
                            alert.warning(res.Message)
                        }
                    })
                    .catch((error) => {
                        setLoading(false)
                        alert.error(error.message)
                    })
            }
            else {
                alert.warning("Veillez renseigner tous les informations.")
            }
        } else {
            alert.warning("Veillez charger la photo de profile de l'utilisateur.")
        }
    }

    const handleChangeEntite = (value: string) => {
        setEntiteVal(value);
        setServices(allServices.filter((s: any) => s.CodeFiliale == value))
    };
    const handleChangeService = (value: string) => {
        setServiceVal(value);
    };



    return (
        <>
            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSection title="Photo & Identifiant" subtitle="Photo de profil et code utilisateur">
                        <div className="eb-form-upload full">
                            <FileUpload
                                files={fileList}
                                onChange={setFileList}
                                maxCount={1}
                                accept='image/png, image/jpeg, image/jpg, image/svg'
                            />
                        </div>
                        <Input
                            {...register("CodeU")}
                            required
                            type='text'
                            label={'Code Utilisateur'}
                            placeholder={"Entrez le code utilisateur"}
                            disabled
                            defaultValue={props.user?.CodeU} />
                        <Input
                            {...register("Mobile")}
                            required
                            type='tel'
                            label={'N° Téléphone'}
                            placeholder={"Entrez le numéro de téléphone"}
                            defaultValue={props.user?.Mobile} />
                    </FormSection>

                    <FormSection title="Identité" subtitle="Nom et prénom de l'utilisateur">
                        <Input
                            {...register("Name")}
                            required
                            type='text'
                            label={'Nom'}
                            placeholder={"Entrez le nom"}
                            defaultValue={props.user?.Name} />
                        <Input
                            {...register("Prenom")}
                            required
                            type='text'
                            label={'Prénom'}
                            placeholder={"Entrez le prénom"}
                            defaultValue={props.user?.Prenom} />
                    </FormSection>

                    <FormSection title="Contact & Groupe" subtitle="Email et groupe d'appartenance">
                        <Input
                            {...register("Email")}
                            required
                            type='email'
                            label={'EMail'}
                            placeholder={"Entrez l'adresse mail de l'utilisateur"}
                            defaultValue={props.user?.Email} />
                        <Input
                            {...register("RoleId")}
                            required
                            type='text'
                            label={"Groupe de l'utilisateur"}
                            placeholder={"Entrez le groupe de l'utilisateur"}
                            defaultValue={props.user?.RoleId} />
                    </FormSection>

                    <FormSection title="Affectation" subtitle="Entité et service de rattachement">
                        <Select
                            label="Entité"
                            value={entiteVal}
                            onChange={handleChangeEntite}
                            options={entites.map((data: any) => ({ value: data.CodeFiliale, label: data.CodeFiliale + ' - ' + data.Libelle }))}
                        />
                        <Select
                            label="Service"
                            value={serviceVal}
                            onChange={handleChangeService}
                            options={services.map((data: any) => ({ value: data.CodeS, label: data.CodeS + ' - ' + data.Libelle }))}
                        />
                    </FormSection>

                    <FormActions>
                        <Button variant='secondary' type='submit' startIcon={<Save size={16} />}>Enregistrer</Button>
                    </FormActions>
                </form>
            </Spin>
        </>
    );
};

export default FormUpdateUser;
